<coop-jatak-form
  [editMode]="false"
  [previousUrl]="previousUrl"
  [successUrl]="successUrl"
  [jatakDefault]="jatakDefault"
></coop-jatak-form>
